import { Button, Input, Select, Upload } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { debounce } from "lodash";
import { useState } from "react";
import { InfoCircleTwoTone, CheckCircleTwoTone, HeartTwoTone, SmileTwoTone, UploadOutlined } from '@ant-design/icons';
import { RcFile } from "antd/es/upload";

export interface Props {
    loading?: boolean
    onChange: (domains: string[]) => void;
}

const DomainFilterBox = (props: Props) => {
    const [domains, setDomains] = useState<string[]>();
    const [fileUploaded, setFileUploaded] = useState<number>();

    function onChange(items: string[]) {
        setDomains(items);
        props.onChange(items);
    }

    function beforeUpload(file: RcFile) {
        file.arrayBuffer().then((val) => {
            const text = new TextDecoder().decode(val);
            const all = text.split('\n');
            setDomains([]);
            setFileUploaded(all.length);
            props.onChange(all);
        });
        return false;
    }

    const placeholderText = fileUploaded ? 'Filtering by ' + fileUploaded + ' domains from file' : 'Filter multiple domains';

    // todo - debounce
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Select value={domains} disabled={props.loading||fileUploaded!=undefined} loading={props.loading} placeholder={placeholderText} style={{ width: '50%' }} tokenSeparators={[',', '\n']} mode="tags" allowClear onChange={onChange} />
            <Upload disabled={props.loading} beforeUpload={beforeUpload}>
                <Button icon={<UploadOutlined />}>Upload Domains to filter</Button>
            </Upload>
        </div>
    );
};

export default DomainFilterBox;
